import { useState } from "react";
import * as yup from "yup";
import { getFields, enderecoValidation, contatoValidation, informacoesGeraisValidation } from "~services/utils/defaultValidations";
import {
  validateBasicFields,
  validateCNPJWithAlpha,
  validateFormatAndSequence,
  validateDigits,
  validateDatabase
} from "../utils/validationHelpers";

const useSender = (id = 0, pessoaFisica = false, validateContato = true) => {
  const [value, setValue] = useState({ name: "", value: "" });

  let dataValidate = {
    contatos: validateContato ? yup.array().of(yup.object({
      ...getFields(contatoValidation(), ['nome', 'sobrenome', 'cargoId', 'email', 'telefone'])
    })) : null,
    ...getFields(informacoesGeraisValidation(), ['usuarioId', 'recebimento', 'dataNascimento', 'trilhaId', 'classificacaoFiscal', 'equipeVendaId', 'escritorioVendaId',
      'grupoSegmentoId', 'segmentoId', 'grupoCentralizadorId', 'descargaCliente', 'paletizado'])
  };

  if (id == 0) {
    dataValidate = {
      ...dataValidate,
      //DADOS CADASTRAIS
      ...getFields(informacoesGeraisValidation(), ['codigoSAP', 'tipo', 'inscricaoEstadual', 'inscricaoMunicipal', 'nomeFantasia', 'documento']),
      documento: yup.string()
        .test("cnpjCpf", "CPF ou CNPJ incompleto!", async function(value) {
          if (!value) {
            return this.createError({ message: "Este campo é obrigatório!" });
          }

          const alnumOnly = value.replace(/[^A-Za-z0-9]/g, "");
          const normalizedAlnum = alnumOnly.toUpperCase();
          const digitsOnly = value.replace(/\D/g, "");
          const hasAlpha = /[A-Za-z]/.test(alnumOnly);
          const isPF = pessoaFisica;


          const basicValidation = validateBasicFields(value, alnumOnly, isPF);
          if (basicValidation) return this.createError(basicValidation);


          const formatValidation = validateFormatAndSequence(value, digitsOnly, isPF, hasAlpha);
          if (formatValidation) return this.createError(formatValidation);

          if (!isPF && hasAlpha) {
            const alphaValidation = validateCNPJWithAlpha(value);
            if (!alphaValidation) return this.createError({ message: "CNPJ inválido!" });
          }

          const digitValidation = validateDigits(digitsOnly, isPF, hasAlpha);
          if (digitValidation) return this.createError(digitValidation);

          const dbValidation = await validateDatabase(normalizedAlnum);
          if (dbValidation) return this.createError(dbValidation);

          return true;
        })
        .nullable()
    };

    if (pessoaFisica) {
      dataValidate = {
        ...dataValidate,
        ...getFields(enderecoValidation(), ['cep', 'numero', 'complemento', 'uf', 'rua', 'bairro', 'cidadeId'])
      };
    }
  }

  const validationSchema = yup.object(dataValidate);

  const [initialValues, setinitialValues] = useState({
    id: 0,
    idVendMais: "",
    codigoVendedor: "",
    conversao: false,
    telefone: "",
    celular: "",
    documento: "",
    dataNascimento: "",
    codigo: "",
    codigoSAP: "",
    codigoProspect: "",
    usuarioId: 0,
    tipo: null,
    inscricaoEstadual: "",
    inscricaoMunicipal: "",
    razaoSocial: "",
    nomeFantasia: "",
    cep: "",
    numero: "",
    contatos: [
      {
        id: 0,
        nome: "",
        sobrenome: "",
        cargoId: null,
        cargo: "",
        email: "",
        telefone: "",
        celular: ""
        // fonte: ""
      },
    ],
    complemento: "",
    uf: "",
    rua: "",
    bairro: "",
    cidadeId: null,
    email: "",
    recebimento: "",
    equipeVendaId: "",
    escritorioVendaId: "",
    trilhaId: "",
    classificacaoFiscal: "",
    grupoSegmentoId: null,
    segmentoId: null,
    grupoCentralizadorId: 0,
    diasAntecipacao: 0,
    descargaCliente: false,
    paletizado: false,
    grupoCentralizadorConstrutoraId: "",
  });

  const cpfCnpj = (newValue) => {
    const numbersOnly = newValue.replaceAll(/\D/g, "");
    if (numbersOnly.length <= 11) {
      // CPF
      return [
        /\d/,
        /\d/,
        /\d/,
        ".",
        /\d/,
        /\d/,
        /\d/,
        ".",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
      ];
    } else {
      // CNPJ
      return [
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        ".",
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        ".",
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        "/",
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        "-",
        /\d/,
        /\d/,
      ];
    }
  };

  const completeDate = (date) => {
    return [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];
  };
  return {
    validationSchema,
    initialValues,
    setinitialValues,
    cpfCnpj,
    setValue,
    value,
    completeDate,
  };
};

export default useSender;
